export default __webpack_public_path__ + "static/pattern-wave.url-8480a94c6962bc10932f3d3afcbe0859.svg";